import React from "react";
import { Box, IconButton, makeStyles } from "@material-ui/core";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";

function ThumbnailImage({
  thumbnail,
  onClick,
}: {
  thumbnail: string;
  onClick?: () => void;
}) {
  const useStyles = makeStyles((theme) => ({
    root: {
      "&:focus": {
        outline: "none", // Remove the focus outline (border effect)
      },
      "&:hover": {
        border: "none", // Remove any hover border effect
      },
    },
  }));
  const classes = useStyles();
  return (
    <Box
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
      style={{ position: "relative", height: "100%", width: "100%" }}
    >
      <img
        src={thumbnail}
        alt="default-diamond.png"
        loading="lazy"
        style={{ height: "100%", width: "100%", maxHeight: "450px" }}
      />

      <IconButton
        className={classes.root}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 999,
        }}
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}
      >
        <PlayArrowIcon
          style={{
            color: "white",
            fontSize: "60px",
          }}
        />
      </IconButton>
    </Box>
  );
}

export default ThumbnailImage;
